import { ReusableFunctions } from './reusable-functions';
import * as Highcharts from 'highcharts';

export class ScorecardsChartOptions {
    constructor() {}
    loadProductMixChartOptions(
        title: string,
        showLegend: boolean,
        chartData: any[],
        header1: string | number,
        header2: string,
        header3: string,
        tooltip: string = '<b>{point.percentage:.1f}%</b>'
    ): Highcharts.Options {
        let highChartsOptions: Highcharts.Options;

        highChartsOptions = {
            chart: {
                spacingBottom: 20,
                spacingLeft: 0,
                marginRight: 0,
                spacingRight: 0,
                spacingTop: 0,
                type: 'pie',
            },
            exporting: {
                enabled: false,
            },
            title: {
                text: title,
                align: 'left',
                x: 14,
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '23px',
                    color: '#223540',
                },
            },
            subtitle: {
                text: ` <span style="font-size:20px; color: #333333; line-height: 30px; font-weight: bold; font-family: roboto;">
                   ${header1}
                 </span>
                 <br>
                 <span style="font-size:9px; color: #333333;font-family: roboto;">
                   <center>${header2}</center>
                 </span>
                  <br>
                 <span style="font-size:9px; color: #333333;font-family: roboto;">
                   <center>${header3}</center>
                 </span>`,
                align: 'center',
                verticalAlign: 'middle',
                y: 40,
                floating: true,
            },
            credits: {
                enabled: false,
            },
            series: chartData,
            tooltip: {
                pointFormat: tooltip,
            },
            legend: {
                align: 'center',
                verticalAlign: 'top',
                layout: 'horizontal',
                y: -2,
            },
            plotOptions: {
                pie: {
                    innerSize: '80%',
                    center: ['50%', '50%'],
                    size: 150,
                },
            },
        };
        return highChartsOptions;
    }

    fundedProductionChartOptions(
        productionSeriesData: Highcharts.SeriesOptionsType[],
        xData: string[],
        yAxisData: Highcharts.YAxisOptions[],
        pageTitle: string
    ): Highcharts.Options {
        let reusableFunctions = new ReusableFunctions();
        let rc: Highcharts.Options = {
            chart: {
                //height: 480,
            },
            credits: {
                enabled: false,
            },
            exporting: {
                enabled: false,
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                y: -23,
            },
            plotOptions: {
                column: {
                    states: {
                        hover: {
                            brightness: -0.3,
                        },
                    },
                    pointWidth: 16,
                    groupPadding: 0,
                    borderRadius: 4,
                },
                line: {
                    marker: {
                        symbol: 'circle',
                    },
                },
            },
            series: productionSeriesData,
            title: {
                text: pageTitle,
                align: 'left',
                x: 22,
                style: {
                    color: '#223540',
                    'font-size': '23px',
                    'font-family': 'Roboto',
                    fill: '#223540',
                },
            },
            tooltip: {
                formatter: function () {
                    let text = '';
                    this.points.forEach((point, i) => {
                        if (i === 0) {
                            text = `<span style="font-size:14px; font-weight: 600">${point.key}</span><table>`;
                        }
                        if (point.y && point.point.properties) {
                            let yValue = '';
                            yValue =
                                point.point.properties.dataType === 'volume'
                                    ? reusableFunctions.formatMoney(point.y)
                                    : point.y
                                    ? point.y.toLocaleString()
                                    : '';

                            text += `<tr><td style="color:${point.color};padding:0"> ${point.series.name}
                                : </td><td style="padding:0; text-align: right"><b>${yValue}</b></td></tr>`;
                        }
                    });
                    return text + '</table>';
                },
                shared: true,
                useHTML: true,
            } as Highcharts.TooltipOptions,
            xAxis: [
                {
                    type: 'category',
                    categories: xData,
                    tickColor: '#FFFFFF',
                    tickLength: 1,
                    tickInterval: 1,
                    pointInterval: 1,
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    title: {
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                } as Highcharts.XAxisOptions,
            ],
            yAxis: yAxisData,
        };
        return rc;
    }
}
